import { Spinner, Typography } from '@weareopenr/component-library';
import { ReactNode } from 'react';
import styles from './SelectableListSection.module.scss';

interface SelectableListSectionProps {
  isLoading: boolean;
  isEmpty: boolean;
  children: ReactNode;
  title?: string;
  rightText?: string;
  emptyMessage?: string;
}

export const SelectableListSection = ({
  title,
  isLoading,
  isEmpty,
  children,
  rightText,
  emptyMessage = 'No results for your search.',
}: SelectableListSectionProps) => {
  return (
    <div className={styles['section-container']}>
      {(title || rightText) && (
        <div className={styles['header']}>
          {title && (
            <Typography size="medium" weight="bold">
              {title}
            </Typography>
          )}
          {rightText && (
            <Typography size="small" className={styles['right-text']}>
              {rightText}
            </Typography>
          )}
        </div>
      )}

      {isLoading && (
        <div className={styles['spinner-container']}>
          <Spinner size="large" colour="rainbow" />
        </div>
      )}

      {!isLoading && isEmpty && <Typography className={styles['empty-message']}>{emptyMessage}</Typography>}

      {!isLoading && !isEmpty && children}
    </div>
  );
};
